import type { ChartDataItem } from "../types";

export const formatLineChartData = (
  data: ChartDataItem[],
  seriesKeys: string[],
  indexBy: string,
): Array<{ id: string; data: Array<{ x: string | number; y: number }> }> =>
  seriesKeys.map(seriesKey => ({
    id: seriesKey,
    data: data.map(item => ({
      x: item[indexBy],
      y: Number(item[seriesKey] || 0),
    })),
  }));
